export const API_SERVER_HOST = process.env.REACT_APP_API_SERVER_HOST;

export const BASE_URL_AUTH = API_SERVER_HOST + '/auth/';
export const BASE_URL_MAIN = API_SERVER_HOST + '/main/';
